import { useEffect, useState, useContext } from "react"
import { Link } from "react-router-dom"
import { CartContext } from "../context/CartContext"
import "./BestSelling.css"

function BestSelling() {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const { addToCart } = useContext(CartContext)

  useEffect(() => {
    fetch("https://data.lacegota.in/api/best-sellers")
      .then(res => res.json())
      .then(data => {
        setProducts(Array.isArray(data) ? data : [])
        setLoading(false)
      })
      .catch(err => {
        console.error("API Error:", err)
        setLoading(false)
      })
  }, [])

  if (loading) return <div className="loadingText">Loading Best Sellers...</div>

  return (
    <section className="bestSellingSection">
      <div className="bestSellerContainer">
        <div className="sectionHeader">
          <h2 className="sectionTitle">🔥 Best Selling Products</h2>
          <p className="sectionSubtitle">Hamaari premium laces jo sabse zyada bikne waali hain</p>
        </div>

        <div className="bestSellingGrid">
          {products.map((p) => {
            // --- Price & Discount Logic ---
            const mktPrice = parseFloat(p.regular_price || 0);
            const salePrice = parseFloat(p.price || 0);
            const discount = mktPrice > salePrice 
              ? Math.round(((mktPrice - salePrice) / mktPrice) * 100) 
              : 0;

            // --- Color Logic ---
            const colorAttr = p.attributes?.find(a => a.name.toLowerCase() === "color");
            const colorName = colorAttr ? colorAttr.options[0] : "Detected";

            return (
              <div className="amazonProductCard" key={p.id}>
                <div className="bestSellerBadge">Best Seller</div>
                
                <Link to={`/product/${p.slug}`} className="cardLink">
                  <div className="cardImgBox">
                    <img 
                       src={p.images?.[0]?.src || "/placeholder.jpg"} 
                       alt={p.name} 
                    />
                  </div>
                  
                  <div className="cardInfo">
                    <h4 className="pName">{p.name}</h4>
                    
                    {/* Color Info */}
                    <div className="pMeta">Color: {colorName}</div>
                    
                    <div className="pRating">⭐⭐⭐⭐⭐ 5.0</div>
                    
                    {/* Amazon Style Price Row */}
                    <div className="priceContainer">
                        <div className="mainPriceRow">
                            {discount > 0 && <span className="pPercentage">-{discount}%</span>}
                            <span className="pCurrency">₹</span>
                            <span className="pPriceBold">{salePrice}</span>
                        </div>
                        {mktPrice > salePrice && (
                            <div className="mktPriceRow">
                                M.R.P.: <span className="pStrike">₹{mktPrice}</span>
                            </div>
                        )}
                    </div>
                  </div>
                </Link>
                
                <button 
                  className="amazonAddBtn" 
                  onClick={() => addToCart(p, 1)}
                >
                  Add to Cart
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  )
}

export default BestSelling;